import { ofType } from 'redux-observable';
import { type Observable, of } from 'rxjs';
import { mergeMap, withLatestFrom } from 'rxjs/operators';
import type { ISupplier as IWeddingSupplier } from '@bridebook/models/source/models/Weddings/Suppliers.types';
import type { IEpicDeps } from '@bridebook/web/lib/types';
import { ShortlistActionTypes } from '../action-types';
import { setSupplierNoteById, updateShortlistedSupplier } from '../actions';

/**
 * Saves a supplier note addressed by id (the AI planner dispatches this raw):
 * the epic resolves the shortlisted supplier from the store and applies the
 * note through the app's own update action. An unknown id is a no-op.
 */
export const setSupplierNoteByIdEpic = (
  action$: Observable<ReturnType<typeof setSupplierNoteById>>,
  { state$ }: IEpicDeps,
) =>
  action$.pipe(
    ofType(ShortlistActionTypes.SET_SUPPLIER_NOTE_BY_ID),
    withLatestFrom(state$),
    mergeMap(([{ payload }, state]) => {
      const supplier = Object.values(state.shortlist.list ?? {}).find(
        (candidate) => candidate.id === payload.supplierId,
      );
      if (!supplier) return of();
      return of(
        updateShortlistedSupplier({
          // The store keeps suppliers serialized (timestamps as numbers) while
          // the action declares the Firestore shape; only the id and the new
          // note are read downstream.
          supplier: supplier as unknown as IWeddingSupplier,
          updatedProperty: { notes: payload.note },
        }),
      );
    }),
  );
